import { EntityType } from './entityTypes';

const l = (str = '') => str.toLowerCase();
const ResourceActions = {
	CREATE: 'CREATE',
	READ: 'READ',
	UPDATE: 'UPDATE',
	DELETE: 'DELETE',
};

// Not all actions are available for now.
const actions = [
  ResourceActions.CREATE,
  ResourceActions.READ,
  ResourceActions.UPDATE,
];  
const resources = [
  EntityType.INVOICE,
  EntityType.QUOTATION,
  EntityType.REPORT,
  EntityType.SOURCE,
];

function createPermissions() {
  return Object.fromEntries(
    actions.map((action) => [
      l(action),
      Object.fromEntries(
        resources.map((resource) => [l(resource), `${l(resource)}:${l(action)}`])
      ),
    ])
  );
}

export default createPermissions();
